import React from "react";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";
import { ServicePageWrapper } from "styling/ServicePagesStyling";
import { LinkToPage } from "../components/LinkToPage";

export const Recruitment = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Rekrytering</title>
        <meta
          name="description"
          content="Vi hjälper ert företag att hitta nästa kvinnliga medarbetare inom tech och it."
        />
        <meta property="og:title" content="We Exist - Rekrytering" />
        <meta
          property="og:description"
          content="Vi hjälper ert företag att hitta nästa kvinnliga medarbetare inom tech och it."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}
      <PageHeading title="Rekrytering" />
      <ServicePageWrapper>
        <img
          src="./service-images/rekrytering.jpg"
          alt="två kvinnor skakar hand"
        />
        <p>
          Vårt mål är att bidra till en mer jämställd arbetsmarknad där ni som
          företag får den kompetens ni behöver och kvinnor kan garanteras en
          arbetsplats som känns respektfull, härlig och inkluderande. För dig
          som kund leder det till en trevligare arbetsplats, gladare och mer
          engagerade medarbetare samt lägre personalomsättning. Dessutom vet du
          ju antagligen att jämställda bolag både är mer lönsamma och
          konkurrenskraftiga, smart av er att fokusera på det! Oavsett om ni
          behöver hjälp att tillsätta en specifik tjänst eller har ett
          återkommande behov av att hitta grymma kvinnor så löser vi det. Vi har
          olika mallar för rekrytering och skräddarsyr vår modell för att passa
          era behov, ni kan till exempel välja att ha ett löpande avtal med oss
          för att säkerställa kontinuerlig kompetensförsörjning. Och don´t you
          worry, vårt löfte är att alltid presentera 100% kvinnor i alla
          rekryteringsprocesser.
        </p>

        <LinkToPage location="/for-foretag" text="Kontakta We Exist" />
      </ServicePageWrapper>
    </>
  );
};
